export default {
  manager: 'Directivo',
  teacher: 'Docente',
  trial: 'Trial',
  admin: 'Directivo',
  secondary: {
    author: 'Autor',
    approvingAuthor: 'Aprobador'
  }
}

export const en = {
  manager: 'Manager',
  teacher: 'Teacher',
  trial: 'Trial',
  admin: 'Manager',
  secondary: {
    author: 'Author',
    approvingAuthor: 'Approver'
  }
}

export const ca = {
  manager: 'Directiu',
  teacher: 'Docent',
  trial: 'Trial',
  admin: 'Directiu',
  secondary: {
    author: 'Autor',
    approvingAuthor: 'Aprovar'
  }
}
